import React, { ReactNode, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { RootState, useAppSelector } from '../store/store'; // use typed selector
import { UserRoleEnum } from '../interfaces/user.interface';

const AdminRoutesGuard = ({ children }: { children?: ReactNode }) => {
  const user = useAppSelector((state: RootState) => state.user.user);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isAdmin =
      !!user &&
      [UserRoleEnum.admin, UserRoleEnum.superAdmin, UserRoleEnum.customerService].includes(user?.role!);
    // Only send admins to the dashboard if they aren't already on it. This effect re-runs whenever
    // the redux `user` object reference changes (e.g. a background refresh after an API call); the
    // previous unconditional navigate('/admin/dashboard') stripped drill-down query params like
    // ?classroomId, bouncing admins out of detail views (tabs, etc.) back to the list.
    if (isAdmin && location.pathname !== '/admin/dashboard') {
      navigate('/admin/dashboard');
    }
  }, [user, navigate, location.pathname]);

  return <div>{children || <Outlet />}</div>;
};

export default AdminRoutesGuard;
